import { PlayerProps, PlayerUi } from 'components/Player';
import PlayerCondensedControls from 'components/Player/controls/PlayerCondensedControls';
import { Audiogram } from 'components/Player/visuals';

export type ThreeByOneWidgetPlayerProps = Partial<
  Pick<PlayerProps, 'controls' | 'visualization' | 'className'>
>;

const ThreeByOneWidgetPlayer: React.FC<ThreeByOneWidgetPlayerProps> = ({
  controls = PlayerCondensedControls,
  visualization = Audiogram,
  className,
}) => <PlayerUi {...{ controls, visualization, className }} />;

export default ThreeByOneWidgetPlayer;
